import { doc, getDoc } from 'firebase/firestore';

import { setIsLoadingFunc, getPostDetail } from '..';
import { db } from '../../utils/firebase-config';

export const fetchPostDetail = (uuid, setTextValue, setEditorValue) => {
    return async (dispatch, getState) => {
        if (uuid) {
            await dispatch(setIsLoadingFunc(true));
            const querySnapshot = await getDoc(doc(db, 'blog-data', String(uuid)));
            await dispatch(getPostDetail(querySnapshot.data()));
            const { postDetail } = getState();
            setTextValue && setTextValue(postDetail?.title);
            setEditorValue && setEditorValue(postDetail?.description);
            await dispatch(setIsLoadingFunc(false));
        }
    };
};
